import React from 'react';
import { useTranslation } from 'react-i18next';

import './ServiceBanner.scss';

import serviceBanner from '../../assets/servicePage/1.webp';

const ServiceBanner = () => {
    const { t } = useTranslation();

    return (
        <section className="service-banner-section section-common section-bg">

            <div className="d-table">
                <div className="d-table-cell">

                    <div className="container">

                        <div className="row align-items-center">

                            <div className="col-lg-5 col-md-6">

                                <div
                                    className="service-banner-text"
                                    data-aos="fade-up"
                                    data-aos-duration="2000"
                                >

                                    <h2>
                                        {t('serviceBanner.title')}
                                    </h2>

                                    <p>
                                        {t('serviceBanner.description')}
                                    </p>

                                    <div className="theme-btn">

                                        <a
                                            href="https://dr-flex.de/embed?medicalPracticeId=53366"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {t('serviceBanner.appointment')}
                                        </a>

                                    </div>

                                </div>

                            </div>

                            <div className="col-lg-7 col-md-6">

                                <div
                                    className="service-banner-img"
                                    data-aos="fade-up"
                                    data-aos-duration="2000"
                                >

                                    <img
                                        src={serviceBanner}
                                        alt={t('serviceBanner.imageAlt')}
                                    />

                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </div>

        </section>
    );
};

export default ServiceBanner;